import { render, staticRenderFns } from "./CategoriesSelect.vue?vue&type=template&id=66b46301&scoped=true"
import script from "./CategoriesSelect.vue?vue&type=script&lang=js"
export * from "./CategoriesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b46301",
  null
  
)

export default component.exports